import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CommandResult } from '@cl/shared/models';
import { FileMetadata } from '@cl/shared/models/file.model';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { FilePreviewModalComponent } from './file-preview-modal/file-preview-modal.component';

@Component({
    selector: 'cl-file-preview',
    standalone: false,
    templateUrl: './file-preview.component.html',
    styleUrl: './file-preview.component.less',
})
export class FilePreviewComponent implements OnChanges, OnDestroy {
    @Input() fileName: string;
    @Input() loadFileMetadata: () => Promise<CommandResult<FileMetadata>>;
    @Input() downloadFile: () => Promise<void>;

    private modal: NzModalRef | null = null;

    constructor(private modalService: NzModalService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (this.modal && changes.fileName) {
            this.close();
        }
    }

    ngOnDestroy(): void {
        this.close();
    }

    open(): void {
        if (this.modal) {
            return;
        }

        const modal = this.modalService.create({
            nzTitle: this.fileName || 'Dokumenta fails',
            nzContent: FilePreviewModalComponent,
            nzWidth: '90%',
            nzFooter: null,
            nzStyle: { top: '1rem' },
            nzData: {
                fileName: this.fileName,
                loadFileMetadata: this.loadFileMetadata,
                downloadFile: this.downloadFile,
            },
        });
        this.modal = modal;
        modal.afterClose.subscribe(() => {
            if (this.modal === modal) {
                this.modal = null;
            }
        });
    }

    close(): void {
        this.modal?.destroy();
        this.modal = null;
    }
}
